import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useDarkMode } from '../context/DarkModeContext';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const { darkMode } = useDarkMode();
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      className={darkMode ? 'dark-theme' : ''}
      sx={{
        mt: 'auto',
        py: 3,
        px: 2,
        textAlign: 'center',
        borderTop: `1px solid ${darkMode ? '#333' : '#e0e0e0'}`,
        backgroundColor: darkMode ? '#1a1a1a' : '#f5f5f5',
        color: darkMode ? '#90caf9' : '#1976d2',
        fontSize: '0.9rem',
        fontWeight: 500
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit'
        }}
      >
        © 2026{' '}
        <Link
          href="https://usefultoolz.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            '&:hover': {
              textDecoration: 'underline',
              color: darkMode ? '#64b5f6' : '#1565c0'
            }
          }}
        >
          usefultoolz.com
        </Link>
        {' | '}
        <Link
          href="https://www.linkedin.com/in/naveen-k-59a99a99/"
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            '&:hover': {
              textDecoration: 'underline',
              color: darkMode ? '#64b5f6' : '#1565c0'
            }
          }}
        >
          Contact Me
        </Link>
        {' | '}
        <Link
          component="button"
          onClick={() => navigate('/faqs')}
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            '&:hover': {
              textDecoration: 'underline',
              color: darkMode ? '#64b5f6' : '#1565c0'
            }
          }}
        >
          FAQs
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer; 